module.exports = __webpack_public_path__ + "static/media/Ogg-Regular.16d4a978.eot";